import { onMounted, onUnmounted } from "vue";
import OrderForm, { OfferJson } from "../OrderForm";
import Tracking from "./Tracking";

export class UserError extends Error {
    json: any;
}

export default class Utils {
    public static async request(method: string, url: string, data?: any) {
        try {
            const r = await $.ajax({
                url: url,
                method: method,
                contentType: method != 'GET' ? 'application/json' : null,
                data: method != 'GET' ? JSON.stringify(data) : data,
            }).promise();

            if (!r.success) {
                throw r;
            }

            return r;
        } catch (e) {
            if (e.responseJSON?.error && e.responseJSON?.message) {
                const ue = new UserError(e.responseJSON?.message);
                ue.json = e.responseJSON;

                throw ue;
            } else if (e.error && e.message) {
                const ue = new UserError(e.message);
                ue.json = e;

                throw ue;
            } else {
                throw new UserError('Wystąpił błąd');
            }
        }
    }

    public static async get(url: string, data?: any) {
        return this.request('GET', url, data);
    }

    public static async post(url: string, data?: any) {
        return this.request('POST', url, data);
    }

    public static async put(url: string, data?: any) {
        return this.request('PUT', url, data);
    }

    public static async delete(url: string, data?: any) {
        return this.request('DELETE', url, data);
    }

    public static async setCart(action: string, data?: any, setoptions: boolean = true) {
        if (!data) {
            data = {}
        }

        data.action = action;

        const r = await Utils.post('/api/cart/set', data);

        if (setoptions) {
            OrderForm.app.options = r.options;
        }

        return r;
    }

    public static scrollToEl($el: JQuery): void {
        if (!$el.length) {
            return;
        }

        jQuery("html, body").animate({
            scrollTop: $el.offset().top - 80,
        }, "slow");
    }

    public static priceFormat(price: number, rounded: boolean, postfix: string = '', round: number = 2): string {
        if (price == null) {
            return null;
        }

        if (rounded) {
            price = Math.round(price);
        }

        return price?.toLocaleString('pl-PL', {
            minimumFractionDigits: rounded ? 0 : round,
            maximumFractionDigits: rounded ? 0 : round,
            useGrouping: true,
        }) + postfix;
    }

    public static usageFormat(usage: number): string {
        if (usage == null) {
            return null;
        }

        return usage?.toLocaleString('pl-PL', {
            useGrouping: true,
        });
    }

    public static monthsTitle(months: number, short: boolean = false): string {
        if (!months) {
            return null;
        }

        if (short) {
            if (months == 1) {
                return '1 mc';
            } else {
                return months + ' mcy';
            }
        } else {
            if (months == 1) {
                return '1 miesiąc';
            } else if (months < 5 || months == 24) {
                return months + ' miesiące';
            } else {
                return months + ' miesięcy';
            }
        }
    }

    public static yearsTitlePostfix(months: number): string {
        switch (months) {
            case 12:
                return 'rok';

            case 24:
                return 'lata';

            case 36:
                return 'lata';

            case 60:
                return 'lat';

            case 120:
                return 'lat';

            default:
                return 'lat';
        }
    }

    public static yearsTitle(months: number): string {
        return Math.round(months / 12) + ' ' + this.yearsTitlePostfix(months);
    }

    public static genUid(): string {
        return (Math.round(Math.random() * 1000000)).toString();
    }

    private static pushUrl(step: string, url: any): void {
        history.pushState({
            app_step: step,
        }, null, url);
    }

    public static changeStep(step: string): void {
    }

    public static getStepUrl(step: string, offer?: OfferJson): string {
        if (Utils.isStep('offers*', step)) {
            switch (step) {
                case 'offers':
                    return '/';

                case 'offers.all':
                    return '/oferty';

                case 'offers.details':
                    return `/${offer.alias}`;

                case 'offers.upload':
                    return `/${offer.alias}/dodawanie-fv`;

                case 'offers.verify':
                    return `/${offer.alias}/dane-do-umowy`;

                case 'offers.form.invoice':
                    return `/${offer.alias}/dane-do-umowy`;

                case 'offers.form.consents':
                    return `/${offer.alias}/dane-osobowe`;

                case 'offers.form.summary':
                    return `/${offer.alias}/umowa`;
            }
        } else if (Utils.isStep('invoice*', step)) {
            switch (step) {
                case 'invoice':
                    return '/dodawanie-fv';

                case 'invoice.recommend':
                    return `/rekomendowana-oferta`;

                case 'invoice.details':
                    return `/rekomendowana-oferta/${offer.alias}`;

                case 'invoice.verify':
                    return `/rekomendowana-oferta/${offer.alias}/dane-do-umowy`;

                case 'invoice.form.invoice':
                    return `/rekomendowana-oferta/${offer.alias}/dane-do-umowy`;

                case 'invoice.form.consents':
                    return `/rekomendowana-oferta/${offer.alias}/dane-osobowe`;

                case 'invoice.form.summary':
                    return `/rekomendowana-oferta/${offer.alias}/umowa`;
            }
        } else if (Utils.isStep('noinvoice*', step)) {
            switch (step) {
                case 'noinvoice.calcform':
                    return `/${offer.alias}/dane-kontaktowe`;

                case 'noinvoice.form.invoice':
                    return `/${offer.alias}/dane-kontaktowe/dane-do-umowy`;

                case 'noinvoice.form.consents':
                    return `/${offer.alias}/dane-kontaktowe/dane-osobowe`;

                case 'noinvoice.form.summary':
                    return `/${offer.alias}/dane-kontaktowe/umowa`;
            }
        } else if (Utils.isStep('sme*', step)) {
            switch (step) {
                case 'sme':
                    return `/dla-firm`;

                case 'sme.upload':
                    if (offer) {
                        return `/dla-firm/dodawanie-fv/${offer.alias}`;
                    } else {
                        return `/dla-firm/dodawanie-fv`;
                    }

                case 'sme.verify':
                    return `/dla-firm/potwierdzenie-danych`;

                case 'sme.offer':
                    return `/dla-firm/${offer.alias}`;

                case 'sme.form.verify':
                case 'sme.form.invoice':
                    return `/dla-firm/${offer.alias}/dane-do-umowy`;

                case 'sme.form.consents':
                    return `/dla-firm/${offer.alias}/dane-osobowe`;

                case 'sme.form.summary':
                    return `/dla-firm/${offer.alias}/umowa`;

                case 'sme.othertariff':
                    return `/dla-firm/ocr/inna-taryfa`;

                case 'sme.nonip':
                    return `/dla-firm/ocr/brak-nip`;

                case 'sme.niperror':
                    return `/dla-firm/ocr/blad-nip`;

                case 'sme.nipreservation':
                    return `/dla-firm/aktywna-umowa`;
            }
        } else {
            switch (step) {
                case 'voucher':
                    return '/voucher';

                case 'voucher.offers':
                    return '/voucher/oferta';
            }
        }

        return null;
    }

    public static setStep(step: string, offer?: OfferJson): void {
        const url = this.getStepUrl(step, offer);

        if (url) {
            OrderForm.app.$data.step = step;

            Utils.setCart('step', {
                step: step,
            });

            Utils.pushUrl(step, url);

            Tracking.doPageView();
        }
    }

    public static isStep(val: string, step: string = null): boolean {
        if (!val?.length) {
            return false;
        }

        const wild = val.match(/\*$/);
        val = wild ? val.substring(0, val.length - 1) : val;

        if (!step) {
            step = OrderForm.app.$data.step;
        }

        if (wild) {
            return step.startsWith(val);
        } else {
            return step == val;
        }
    }

    public static attachBodyClass(pagename: string|string[]): void {
        let list = [];

        if (typeof pagename == 'string') {
            list.push('body--' + pagename);
        } else {
            list = pagename;
        }

        onMounted(() => {
            $('body').addClass(list);
        });

        onUnmounted(() => {
            $('body').removeClass(list);
        });
    }

    public static hideGreenTerms(): void {
        onMounted(() => {
            $('.footer-terms__green').hide();
        });

        onUnmounted(() => {
            $('.footer-terms__green').show();
        });
    }
};
